import React, { useState } from "react";
import emailjs from "emailjs-com";
import "../assets/css/contactoPag.css";
import enviar from "../assets/svg/Enviar.svg";
import whatsApp from "../assets/icons/Whatsapp.svg";
import flechaDoble from "../assets/svg/FlechaDoble.svg";
import fachada from "../assets/img/fachada.jpg";
import telefono from "../assets/svg/Telefono.svg";
import { PuffLoader } from "react-spinners";

const ContactoPag = () => {
  const [form, setForm] = useState({
    nombres: "",
    apellidos: "",
    correoElectronico: "",
    numeroTelefono: "",
    consulta: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setShowModal(true);

    emailjs
      .send("service_0yqdsmk", "template_vflg0vo", form, "FiOrOg8ZmLDpRXaoR")
      .then(() => {
        setLoading(false);
        setSubmitted(true);
        setForm({
          nombres: "",
          apellidos: "",
          correoElectronico: "",
          numeroTelefono: "",
          consulta: "",
        });

        setTimeout(() => {
          setSubmitted(false);
          setShowModal(false);
        }, 4000);
      })
      .catch((error) => {
        setLoading(false);
        alert("Error al enviar el mensaje");
        console.error(error);
      });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="contenedorContacto contacto-negro">
      <div className="contenedorContacto">
        <div className="subContenedorTitulo">
          <h1>Estamos aquí para ayudarte, Contáctanos.</h1>
          <p>
            En Torres y Torres, nuestra prioridad es brindarte asesoría legal
            experta. Completa el formulario y nos pondremos en contacto contigo
            a la brevedad.
          </p>
        </div>
        <div className="subContenedorConsulta">
          <div className="card-contactos">
            <div className="consultas">
              <div className="tituloConsultas">
                <h1>¿Tienes Alguna Consulta?</h1>
                <h2>¡Estamos Aquí Para Ayudarte!</h2>
              </div>
              <div className="informacion">
                <h3>
                  Déjanos tus datos y uno de nuestros especialistas se pondrá en
                  contacto contigo lo antes posible o puedes escribirnos a
                  nuestro
                  <span className="text-color"> WhatsApp</span>.
                  <img
                    className="telefono"
                    src={telefono}
                    alt="Icono de whatsapp"
                  />
                </h3>
              </div>
              <div className="boton-escribenos">
                <a
                  href="https://wa.me/51988070758"
                  target="_blank"
                  rel="noopener noreferrer">
                  <button>
                    <img
                      className="whatsApp"
                      src={whatsApp}
                      alt="Icono de WhatsApp"
                    />
                    ¡Escríbenos!
                  </button>
                </a>
                <img
                  className="flechaDoble"
                  src={flechaDoble}
                  alt="Flecha señalando a botón"
                />
              </div>
            </div>
            <form className="card-cliente" onSubmit={handleSubmit}>
              <div className="info-Nombres">
                <div className="nombres">
                  <h2>Nombres</h2>
                  <input
                    type="text"
                    name="nombres"
                    placeholder="Ingrese Nombres"
                    value={form.nombres}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="apellidos">
                  <h2>Apellidos</h2>
                  <input
                    type="text"
                    name="apellidos"
                    placeholder="Ingrese Apellidos"
                    value={form.apellidos}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="info-Correos">
                <h2>Correo Electrónico</h2>
                <input
                  type="email"
                  name="correoElectronico"
                  placeholder="Ingrese correo electrónico"
                  value={form.correoElectronico}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="info-Telefono">
                <h2>Número de Teléfono</h2>
                <input
                  type="text"
                  name="numeroTelefono"
                  placeholder="Ingrese su número telefónico"
                  value={form.numeroTelefono}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 9);
                    handleChange({ target: { name: "numeroTelefono", value } });
                  }}
                  maxLength="9"
                  required
                  style={{
                    appearance: "none",
                    MozAppearance: "textfield",
                  }}
                />
              </div>
              <div className="info-Consulta">
                <h2>Motivo de su consulta</h2>
                <textarea
                  name="consulta"
                  placeholder="Escriba el motivo por el cual nos está contactando"
                  rows="5"
                  cols="30"
                  value={form.consulta}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="info-button">
                <div className="enviarConsulta">
                  <button type="submit">
                    Enviar Consulta <img src={enviar} alt="botón de enviar" />
                  </button>
                </div>
                <p>
                  Te responderemos en menos de 24 horas. Gracias por confiar en
                  Torres & Torres.
                </p>
              </div>
            </form>
          </div>
        </div>
        <div className="subContedorUbicacion">
          <div className="ubicacionTitulo">
            <h2>Conoce Nuestras Oficinas</h2>
            <p>Ubícanos en Los Cocoteros 473, Víctor Larco Herrera 13009 </p>
          </div>
          <div className="ubicacionLocalizacion">
            <div className="contenedorSecundario">
              <img src={fachada} alt="fachada del domicilio" />

              <iframe
                title="Mapa ubicación Torres & Torres"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d441.23169604617993!2d-79.03935294294219!3d-8.141713177079057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91ad3d40e0de373f%3A0xb421153a9c53afba!2sLos%20Cocoteros%20473%2C%20V%C3%ADctor%20Larco%20Herrera%2013009!5e0!3m2!1ses!2spe!4v1743615657136!5m2!1ses!2spe"
                allowFullScreen
                loading="lazy"></iframe>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <button
              className={`close-button ${!loading && submitted ? "show" : ""}`}
              onClick={handleCloseModal}>
              ×
            </button>
            {loading ? (
              <div className="loading-spinner">
                <PuffLoader color="#E0BA56" size={80} />
              </div>
            ) : submitted ? (
              <div className="mensaje-exito">
                <h2>
                  ¡Gracias por contactarnos! Hemos recibido tu mensaje y te
                  responderemos a la brevedad.
                </h2>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactoPag;
